// Lookup_CoachingEventType
export enum CoachingEventType {
    OBSERVATION = 1,
    COMMITMENT,
    COMMITMENT_UPDATE,
}
